import { CalendarDays, BookOpen, Sparkles, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router';
import RubikooBrand, { RubikooMark } from '../components/RubikooBrand';
import LegalLinks from '../components/LegalLinks';
import { markWelcomeSeen } from '../utils/welcomeExperience';

export default function WelcomeScreen() {
  const navigate = useNavigate();
  const continueTo = (path: '/signin' | '/signup') => {
    markWelcomeSeen();
    navigate(path, { replace: true });
  };

  return (
    <main className="rubikoo-auth-page size-full flex flex-col overflow-y-auto px-6" style={{ background: 'var(--app-bg)' }}>
      <header className="pt-6 pb-6"><RubikooBrand /></header>
      <div className="flex-1 flex flex-col justify-center">
        <div className="rubikoo-welcome-visual relative flex items-center justify-center rounded-3xl border mb-8" aria-hidden="true">
          <div className="absolute inset-5 rounded-full border" style={{ borderColor: 'var(--app-accent-border)' }} />
          <div className="rounded-3xl size-24 flex items-center justify-center border" style={{ background: 'var(--app-bg)', borderColor: 'var(--app-accent-border)', boxShadow: '0 12px 40px var(--app-accent-dim)' }}>
            <RubikooMark className="size-14" />
          </div>
          <span className="rubikoo-welcome-tile absolute left-5 top-6 -rotate-6"><CalendarDays className="size-6" /></span>
          <span className="rubikoo-welcome-tile absolute right-5 top-8 rotate-6"><Sparkles className="size-6" /></span>
          <span className="rubikoo-welcome-tile absolute right-10 bottom-5 -rotate-6"><BookOpen className="size-6" /></span>
        </div>
        <p className="text-xs uppercase tracking-[0.2em] font-semibold mb-3" style={{ color: 'var(--app-accent)' }}>Welcome to Rubikoo</p>
        <h1 className="text-4xl font-semibold tracking-tight leading-tight" style={{ color: 'var(--app-text)' }}>Your event, <span className="block">made easier.</span></h1>
        <p className="text-base leading-relaxed mt-4 mb-8" style={{ color: 'var(--app-text-muted)' }}>
          Explore sessions, discover research, and get help from your event’s AI assistant when available.
        </p>
      </div>
      <div className="flex flex-col gap-3">
        <button type="button" onClick={() => continueTo('/signin')} className="h-14 rounded-xl flex items-center justify-center gap-2 text-white font-semibold active:opacity-80" style={{ background: 'var(--app-accent-solid)' }}>
          Sign in <ArrowRight className="size-5" aria-hidden="true" />
        </button>
        <button type="button" onClick={() => continueTo('/signup')} className="h-14 rounded-xl border font-semibold active:opacity-80" style={{ color: 'var(--app-text)', background: 'var(--app-surface)', borderColor: 'var(--app-border)' }}>
          Create account
        </button>
      </div>
      <footer className="pt-3"><LegalLinks /></footer>
    </main>
  );
}
